import EventThumbnail from "./EventThumbnail";

// Web port of EventArtworkHeader
// (EventsFeature/View/Component/EventArtworkHeader.swift).
//
// Artwork with the title laid over the bottom-left, darkened by a gradient so
// the text stays legible against any image. The caller owns the height.

export interface EventArtworkHeaderProps {
  url: string | null;
  /** Small uppercase label above the title. */
  eyebrow?: string;
  title: string;
  description?: string | null;
}

export default function EventArtworkHeader(props: EventArtworkHeaderProps) {
  return <div className="relative size-full overflow-hidden">
    <EventThumbnail url={props.url} />

    {/* LinearGradient(.clear -> .black.opacity(0.5), top -> bottom) */}
    <div className="absolute inset-0 bg-linear-to-b from-transparent to-black/90" />

    <div className="absolute inset-x-0 bottom-0 px-4 pb-3 text-left text-white">
      {props.eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-wide opacity-75">
          {props.eyebrow}
        </p>
      )}

      <h3 className="text-[22px] font-bold leading-tight">{props.title}</h3>

      {props.description && (
        <p className="line-clamp-3 text-[13px] leading-snug opacity-75">
          {props.description}
        </p>
      )}
    </div>
  </div>
}
